<script>
    export let _click = () => {}
</script>

<div class='overlay' on:click={_click} on:keypress={()=>{}}></div>


<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        z-index: -1;
        backdrop-filter: blur(3px);
    }
</style>
